import { render, staticRenderFns } from "./Trusted.vue?vue&type=template&id=b7ecdeb2&scoped=true&"
import script from "./Trusted.vue?vue&type=script&lang=js&"
export * from "./Trusted.vue?vue&type=script&lang=js&"
import style0 from "./Trusted.vue?vue&type=style&index=0&id=b7ecdeb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ecdeb2",
  null
  
)

export default component.exports